import { closestCenter, DragDropProvider, DragDropSensors, DragOverlay } from "@thisbeyond/solid-dnd";
import { getOverlay } from "../../utils/dragUtil";
import type { ParentComponent } from "solid-js";
import { cloneDeep } from "lodash-es";

const X_AXIS_EDITOR_PADDING = 28;
const OVERLAY_ID = "draggableOverlay";

const FormEditorDragDropProvider: ParentComponent = (props) => (
  <DragDropProvider
    collisionDetector={(draggable, droppables, context) => {
      const scopedDroppables =
        draggable.transformed.x > droppables[0].transformed.left - X_AXIS_EDITOR_PADDING &&
        draggable.transformed.x < droppables[0].transformed.right + X_AXIS_EDITOR_PADDING
          ? droppables
          : [];

      // Necessary in order to set the correct height of the draggable, modifying the original object does not work
      const mutableDraggable = cloneDeep(draggable);
      const draggableHeight = document.getElementById(OVERLAY_ID)?.clientHeight ?? 0;
      const draggableWidth = document.getElementById(OVERLAY_ID)?.clientWidth ?? 0;
      mutableDraggable.transformed.height = draggableHeight;
      mutableDraggable.transformed.width = draggableWidth;

      return closestCenter(mutableDraggable, scopedDroppables, context);
    }}
  >
    <DragDropSensors />
    {props.children}
    <DragOverlay class="z-10">{(draggable) => <div id={OVERLAY_ID}>{getOverlay(draggable)}</div>}</DragOverlay>
  </DragDropProvider>
);

export default FormEditorDragDropProvider;
